import { CohortBuilderStepLegacy } from '@verantos-dev/types-cohorts';

export const COHORT_BUILDER_SLICE_KEY = 'cohortBuilder';
export const DEFAULT_COHORT_BUILDER_STEP = CohortBuilderStepLegacy.EVENTS;

// width of the components in a CohortBuilderEditModalFilter
export const COMPONENT_COMBOBOX_X_WIDE = 470; // extra extra wide combobox
export const COMPONENT_COMBOBOX_WIDE = 402; // wide combobox
export const COMPONENT_COMBOBOX_MEDIUM = 384; // medium combobox
export const COMPONENT_COMBOBOX_MEDIUM_SMALL = 360; // medium combobox
export const COMPONENT_COMBOBOX_NARROW = 292; // narrow combobox
export const COMPONENT_DROPDOWN_X_WIDE = 384; // extra extra wide dropdown
export const COMPONENT_DROPDOWN_XX_WIDE = 448; // extra extra wide dropdown
export const COMPONENT_DROPDOWN_WIDE = 232; // wide dropdown
export const COMPONENT_DROPDOWN_X_MEDIUM = 226; // medium dropdown
export const COMPONENT_DROPDOWN_MEDIUM = 162; // medium dropdown
export const COMPONENT_DROPDOWN_NARROW = 96; // narrow dropdown
export const COMPONENT_NUMERIC_INTEGER = 96; // numeric input
export const COMPONENT_CHECKBOX = 110; // checkbox
export const COMPONENT_RADIO = 110; // radio

export const COMPONENT_DEFAULT = 232; // default width

// width for CohortBuilderItemViewCard
export const SINGLE_ENTRY_WIDTH = 'auto';
export const MULTIPLE_ENTRIES_WIDTH = ['auto', 318];

// width for CohortBuilderEditModalSummary
export const NAME_WIDTH = 380;
export const TYPE_WIDTH = 220;
export const NAME_MAX_CHARACTER_LENGTH = 214;
export const NAME_VALID_CHARACTERS = /[a-z0-9><=≥≤+\-_– ~`!@#$%^&*(){}[\]|\\/:;'"’,.?ö]/i;
export const NAME_VALID_CHARACTERS_WITHOUT_DOUBLE_QUOTE =
  /[a-z0-9><=≥≤+\-_– ~`!@#$%^&*(){}[\]|/;'’,.?ö]/i;

export const TOKEN_OFFSET = 2;

export const STUDY_PERIOD_RESTRICTION = 'Study period restriction';
export const OBSERVATION_PERIOD_BASELINE_RESTRICTION = 'Minimum baseline period';
export const OBSERVATION_PERIOD_FOLLOW_UP_RESTRICTION = 'Minimum follow-up period';
